export const actionTypes = {
  setAuthUser: "SET_AUTH_USER"
}